<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Employee ID</label>
            <i
              v-if="filters.employee_id"
              @click="handleClearOneFilter('employee_id')"
              class="fa-solid fa-xmark filter-clear-icon"
            ></i>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="filters.employee_id"
            @focus="isFocused = true"
            @blur="isFocused = employee_id !== ''"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Employee Name</label>
            <i
              v-if="filters.employee_name"
              @click="handleClearOneFilter('employee_name')"
              class="fa-solid fa-xmark filter-clear-icon"
            ></i>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="filters.employee_name"
            @focus="isFocusedOn = true"
            @blur="isFocusedOn = employee_name !== ''"
          />
        </div>
      </div>
      <!-- <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :style="`${ filters.leave_type_id && 'border-bottom: var(--primary-color) 2px solid;'}`"
            :options="leaveTypes"
            v-model="filters.leave_type_id"
            placeholder="Select Leave Type"
            id="leaveType"
            :disabled="leaveTypesLoading"
            @mouseenter.once="fetchLeaveTypes"
          />
          <label class="focus-label">Leave Type</label>
        </div>
        <i
          v-if="filters.leave_type_id"
          @click="handleClearOneFilter('leave_type_id')"
          class="fa-solid fa-xmark filter-clear-icon"
          :style="{ position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer' }"
        ></i>
      </div> -->
      <!-- <div class="col-md-3"></div> -->
      <div class="d-flex align-items-end col-sm-6 col-md-3 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import LeaveTypeService from "@/services/LeaveTypeService";

export default {
  data() {
    return {
      filters: {
        employee_id: "",
        employee_name: "",
        // leave_type_id: "",
      },
      isFocused: false,
      isFocusedOn: false,
      leaveTypes: [],
      leaveTypesLoading: false,
      leaveTypesLoaded: false,
      searched: false,
    };
  },
  props: {
    forClient: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFilters() {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },

    handleClearOneFilter(fieldName) {
      this.filters[fieldName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", this.filters);

      this.searched = false;
    },

    async fetchLeaveTypes() {
      if (this.leaveTypesLoading || this.leaveTypesLoaded) return;
      this.leaveTypesLoading = true;
      try {
        const response = this.forClient ? await LeaveTypeService.fetchClientLeaveTypes() : await LeaveTypeService.fetchLeaveTypes();
        this.leaveTypes = response?.data.map((el) => ({
          id: el.id,
          text: el.leave_type,
        }));
        this.leaveTypesLoaded = true;
      } catch (error) {
        console.error("Error fetching leave types:", error);
      } finally {
        this.leaveTypesLoading = false;
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        employee_id: "",
        employee_name: "",
        // leave_type_id: "",
      };
      this.searched = false;
    },
  },
  created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  padding: 0;
}

.filter-label-row .filter-label {
  margin: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

.input-block .form-control {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  font-size: 12.5px !important;
  transition: all 0.2s ease;
}

.input-block .form-control:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
